import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, ModalCloseButton, useDisclosure, useToast } from '@chakra-ui/react'
import { Button } from '../../../../components/Button'
import { api } from '../../../../services/api'
import { useMutation, useQueryClient } from 'react-query'
import { useNavigate } from 'react-router-dom'

async function transformarEmProposta({ numeroPedido }) {
  const response = await api.put('/site/v2/orcamento-crm/atualiza-retorno-orcamento', {
    numero_pedido: numeroPedido,
  })

  return response.data
}

export function TransformarProposta({ numeroPedido, numeroNota }) {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const toast = useToast({
    position: 'top-right',
    duration: 9000,
    isClosable: true,
  })

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: transformarEmProposta,
    onSuccess: (data) => {
      console.log('data', data)

      toast({
        title: 'Proposta transformada com sucesso',
        status: 'success',
      })

      queryClient.clear()

      navigate(`/vendas/orcamento-pedido/${numeroNota}`)
    },
    onError: (error) => {
      console.log('error', error)
    },
  })

  async function handleTransformarProposta() {
    await mutateAsync({
      numeroPedido,
    })
  }

  return (
    <>
      <Button mr="auto" onClick={onOpen}>
        Transformar em Proposta
      </Button>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Atenção!</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <p>
              Você tem certeza que quer voltar o pedido para proposta? essa ação vai tirar todas as aprovações/pagamentos do pedido e o cliente terá
              que fazer novamente.
            </p>
          </ModalBody>
          <ModalFooter>
            <Button bgColor="red.500" onClick={onClose} mr={2}>
              Não
            </Button>
            <Button onClick={handleTransformarProposta} isLoading={isLoading} bgColor="green.500">
              Sim
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
